/**
 * meeting.tencent.com后台服务对应的路径配置
 */
export enum HttpPrefix {
  WEMEET_WEB_API = '/wemeet-webapi',
  WEMEET_TAPI = '/wemeet-tapi',
  NEXT_API = '/v2/api',
  WEMEET_CLOUDRECORDING_API = '/wemeet-tapi/v2/wemeet-cloudrecording-webapi',
  EMPTY = '',
  YAPI_API = '/yapi-api',
  WEB_SERVICE = '/web-service',
}
